/* eslint-disable jsx-a11y/anchor-is-valid */
import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { Dashboard } from "../../modules/dashboard/component/dashboard";

const DashboardContext = createContext();

const DashboardWrapper = () => {
  const value = {};

  return (
    <DashboardContext.Provider value={value}>
      <Routes>
        <Route path="" element={<Dashboard />} />
        <Route path=":inboxId" element={<Dashboard />} />
      </Routes>
    </DashboardContext.Provider>
  );
};

export { DashboardWrapper };
